import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { media } from 'context';
import { Button, Layout, Modal, Text, TextButton } from 'ds';
import { AI_ASSISTANT_PATH } from 'routes/paths';

interface ConsumablesOnboardingInfoModalProps {
  isVisible: boolean;
  onClose: () => void;
}

const ConsumablesOnboardingInfoModal: React.FC<ConsumablesOnboardingInfoModalProps> = ({ isVisible, onClose }) => {
  const history = useHistory();
  const { isMobile } = useContext(media);
  return (
    <Modal
      width={isMobile ? 390 : 500}
      isBottomSheet={isMobile}
      bottomSheetIsRounded={isMobile}
      onClose={onClose}
      headerAlign="left"
      isVisible={isVisible}
      header="About your restocking service"
      footer={
        <Layout width="100%" justify="center">
          <Button onClick={onClose} size="sm" type="primary" text={'Got it'} fullWidth={isMobile} />
        </Layout>
      }
    >
      <Layout direction="column" gap={20} paddingX={isMobile ? 24 : undefined}>
        <Layout direction="column" gap={7}>
          <Text size="body-md" semibold>
            How is it different from Amazon or Instacart?
          </Text>
          <Text size="body-sm" color="gray-700">
            Forget the hassle of endless boxes and wasted time unpacking! Unlike Amazon or Instacart, our restocking
            service ensures your supplies magically appear exactly where they belong. No more unboxing, stocking
            shelves, or breaking down cardboard on your own. We save you precious hours every week, so you can stay
            focused on your business.
          </Text>
        </Layout>
        <Layout direction="column" gap={7}>
          <Text size="body-md" semibold>
            Can I change just my upcoming order?
          </Text>
          <Text size="body-sm" color="gray-700">
            Absolutely. You can adjust items, change quantities, or skip your next order up to 8 business days before
            delivery.
          </Text>
        </Layout>
        <Layout direction="column" gap={7}>
          <Text size="body-md" semibold>
            Can I change my repeat items?
          </Text>
          <Text size="body-sm" color="gray-700">
            Definitely! You can always manage your recurring orders from “Your subscription” or directly from the Shop.
          </Text>
        </Layout>
        <Layout direction="column" gap={7}>
          <Text size="body-md" semibold>
            How does pricing compare to retail?
          </Text>
          <Text size="body-sm" color="gray-700">
            Items are sometimes priced a few dollars higher than retail as they include the restocking service, saving
            your team hours every other week.
          </Text>
        </Layout>
        <Layout direction="column" gap={7}>
          <Text size="body-md" semibold>
            How do I cancel my pantry restocking service?
          </Text>
          <Layout direction="row" gap={4} align="center">
            <TextButton
              text="Contact us"
              color="blue-400"
              semibold={false}
              textSize="body-sm"
              onClick={() => history.push(AI_ASSISTANT_PATH)}
            />
            <Text size="body-sm" color="gray-700">
              to cancel your service
            </Text>
          </Layout>
        </Layout>
      </Layout>
    </Modal>
  );
};

export default ConsumablesOnboardingInfoModal;
